<template>
	<div class="webContent flex">
		<div class="remind">
			<div class="model df hao">
				<div class="modelLi flex" :class="{ cur: chooseModel=='manualCheck' }" @click="tabModel('manualCheck')">人工审核</div>
				<div class="modelLi flex" :class="{ cur: chooseModel=='answerManager' }" @click="tabModel('answerManager')">回答与管理</div>
				<div class="modelLi flex" :class="{ cur: chooseModel=='archiveManager' }" @click="tabModel('archiveManager')">归档管理</div>
			</div>
			<!-- 人工审核 -->
			<div class="list" v-show="chooseModel=='manualCheck'" @scroll="listenScroll_manualCheck">
				<div class="li" v-for="(v,i) in manualCheckList" :key="i">
					<div class="title">{{v.title + '【' + replaceStr(v.categoryName) + '】'}}</div>
					<div class="txt" v-html="v.txt" v-show="v.open">{{v.txt}}</div>
					<div class="df war">
						<div class="open" :class="{ cur: v.open }" @click="openLi(i)">{{v.open?'收起':'展开'}}</div>
					</div>
					<!-- <div class="file">
						<div class="fileLi df">
							<div class="fileName flex">xxx.pdf</div>
							<a class="df wao hao" href="http://www.baidu.com" target="_blank">下载</a>
						</div>
						<div class="fileLi df">
							<div class="fileName flex">xxx.pdf</div>
							<a class="df wao hao" href="http://www.baidu.com" target="_blank">下载</a>
						</div>
					</div> -->
					<div class="relation ov-d" v-if="v.relation.id!=''" @click="toDetail({ id: v.relation.id })">原始问题：{{v.relation.title}}</div>
					<div class="tool df hao">
						<div class="flex"><em>{{v.date}}</em> · {{v.user}}（{{v.account}}）</div>
					</div>
					<div class="tool-btn">
						<div class="change-btn" v-if="$h5Power=='teacher'|| $h5Power=='admin' || $h5Power == 'instructor'"
							@click="changeSection(v)">更改版块</div>
						<div class="checkBtn" @click="openConfirm('check',v.title,v)">通过</div>
						<div class="checkBtn2" @click="openReject(v.title,v)">驳回</div>
					</div>
				</div>
			</div>
			<!-- 回答与管理 -->
			<div class="list" v-show="chooseModel=='answerManager'" @scroll="listenScroll_answerManager">
				<div class="li2" v-for="(v,i) in answerManagerList" :key="i">
					<div class="cap df hao jcb">
						<div class="state" v-if="v.state==1">状态：超时</div>
						<div class="state2" v-else-if="v.state==2">状态：即将超时</div>
						<div class="state3" v-else-if="v.state==3">状态：正常</div>
						<span v-html="v.stateTxt">{{v.stateTxt}}</span>
					</div>
					<div class="item" @click="toDetail(v)">
						<div class="title">{{v.title}}</div>
						<!-- <div class="txt" v-html="v.txt" v-if="v.txt!=''">{{v.txt}}</div> -->
					 <div class="flex ov-d question_user"><em>{{v.date}}</em> · <strong>{{v.user}}（{{v.account}}）</strong></div>
						<div class="tool df hao">
						
							<div class="topBtn" :class="{ has: v.type.indexOf('top')>=0 }" @click.stop.prevent="openConfirm('top',v.title,v,v.type.indexOf('top')>=0)">置顶</div>
							<div class="prizeBtn" :class="{ has: v.type.indexOf('prize')>=0 }" @click.stop.prevent="openConfirm('prize',v.title,v,v.type.indexOf('prize')>=0)">加精</div>
							<div class="removeBtn" @click.stop.prevent="openConfirm('remove',v.title,v)">删除</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 归档管理 -->
			<div class="list2" v-show="chooseModel=='archiveManager'" @scroll="listenScroll_archiveManager">
				<div class="li3" v-for="(v,i) in archiveManagerList" :key="i">
					<div class="cap"><em>{{v.creatorName}}</em><i>|</i>{{returnRetDate(v.createTime)}} 回答了问题
						<div class="recovery" @click="openConfirm('archive','',v)">恢复</div>
					</div>
					<div class="item">
						<div class="title"><i v-if="v.announcement==1" class="rule"></i><i v-if="v.refining==1" class="prize"></i><i v-if="v.top==1" class="top"></i>{{v.title}}</div>
						<div class="txt ov-4d" v-html="v.txt">{{v.txt}}</div>
						<div class="end df hao">
							<div class="like" :class="{ has: v.approval!=0 }" @click="likeItem('归档中的问题不可点赞！')">{{v.approvalTotal}}</div>
							<div class="collect" :class="{ has: v.collection!=0 }" @click="collectItem('归档中的问题不可收藏！')">{{v.collectionTotal}}</div>
							<div class="flex"></div>
							<div class="date">{{dateTime(v.createTime)}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 确认弹框 -->
		<div class="confirm df wao hao" v-if="confirm.has">
			<div class="confirm-box">
				<div class="confirm-txt df wao" v-if="confirm.type=='check'">确认<em>通过</em>“<div class="ov-d" :class="{ flex: confirm.txt.length>6}">{{confirm.txt}}</div>”该问题审核吗？</div>
				<div class="confirm-txt df wao" v-else-if="confirm.type=='top'">确认对“<div class="ov-d" :class="{ flex: confirm.txt.length>6}">{{confirm.txt}}</div>”该问题<em>{{confirm.state==2?'取消':''}}置顶</em>操作吗？</div>
				<div class="confirm-txt df wao" v-else-if="confirm.type=='prize'">确认对“<div class="ov-d" :class="{ flex: confirm.txt.length>6}">{{confirm.txt}}</div>”该问题<em>{{confirm.state==2?'取消':''}}加精</em>操作吗？</div>
				<div class="confirm-txt df wao" v-else-if="confirm.type=='remove'">确认对“<div class="ov-d" :class="{ flex: confirm.txt.length>6}">{{confirm.txt}}</div>”该问题<em>删除</em>操作吗？</div>
				<div class="confirm-txt df wao" v-else-if="confirm.type=='archive'">确认<em>取消归档</em>操作吗？</div>
				<div class="confirm-end df war hao">
					<div class="confirm-btn" @click="resConfirm" v-if="confirm.type=='check'">确定</div>
					<div class="confirm-btn" @click="resConfirm" v-else-if="confirm.type=='top'">{{confirm.state==2?'取消':'确定'}}置顶</div>
					<div class="confirm-btn" @click="resConfirm" v-else-if="confirm.type=='prize'">{{confirm.state==2?'取消':'确定'}}加精</div>
					<div class="confirm-btn" @click="resConfirm" v-else-if="confirm.type=='remove'">确定删除</div>
					<div class="confirm-btn" @click="resConfirm" v-else-if="confirm.type=='archive'">确定</div>
					<div class="confirm-btn" @click="closeConfirm">取消</div>
				</div>
			</div>
		</div>

		<!-- 驳回弹框 -->
		<div class="reject df wao hao" v-if="reject.has">
			<div class="reject-box">
				<div class="reject-txt df">确认<em>驳回</em>“<div class="flex ov-d">{{reject.txt}}</div>”该问题审核吗？</div>
				<div class="reject-val">
					<div class="reject-tag">
						<div class="reject-tagItem" v-for="(v,i) in reject.tag" @click="chooseRejectTag(v)" :key="i">{{rejectArr[v]}}</div>
					</div>
					<reject-textarea id="rejectTextareaObj" ref="rejectTextarea" class="reject-textarea" :data-empty="reject.remark.length==0&&reject.tag.length==0?'请输入驳回理由':''" v-model="reject.remark"></reject-textarea>
				</div>
				<div class="reject-tagCap">添加驳回理由</div>
				<div class="reject-tagList">
					<div class="reject-tagLi" :class="{ cur: reject.tag.indexOf(i)>=0 }" v-for="(v,i) in rejectArr" @click="chooseRejectTag(i)" :key="i">{{v}}</div>
				</div>
				<div class="reject-end df war hao">
					<div class="reject-btn" :class="{ none: reject.remark.length==0&&reject.tag.length==0 }" @click="resReject">驳回</div>
					<div class="reject-btn" @click="closeReject">取消</div>
				</div>
			</div>
		</div>

		<!-- 更改模块 -->
		<div class="collectBase" v-if="isChangeSec">
			<div class="collectBase-box">
				<div class="collectBase-top">
					<div class="collectBase-close" @click="closeCollectBase"></div>
				</div>
				<div class="collectBase-list">
					<div class="collectBase-li df cf wao" 
						:class="{ cur: choose.indexOf(i)>=0 }" 
						v-for="(v, i) in sectionList" :key="i"
						@click="chooseCollectBase(i)">
						<div class="collectBase-title">{{v.name ? replaceStr(v.name) : ''}}</div>
					</div>
				</div>
				<div class="collectBase-btn" @click="resCollectBase">确认</div>
			</div>
		</div>
	</div>
</template>

<script>
	import h5PublicApi from '../../../script/public.js'
	import reject_textarea from './reject-textarea.vue'

	var answerManager_clock = {};

	export default {
		name: 'admin_index_page',
		data () {
			return {
				chooseModel: h5PublicApi.tabNavTed('get','adminIndexModel','manualCheck'),
				pagenum_manualCheck: 1,
				pagesize_manualCheck: 10,
				state_manualCheck: false,
				manualCheckList: [],
				pagenum_answerManager: 1,
				pagesize_answerManager: 10,
				state_answerManager: false,
				answerManagerList: [],
				pagenum_archiveManager: 1,
				pagesize_archiveManager: 10,
				state_archiveManager: false,
				archiveManagerList: [],
				confirm: {
					id: '',
					has: false,
					state: 1,
					type: '',
					typeArr: '',
					txt: '',
				},
				rejectArr: [
					'问题中包含敏感词',
					'已有类似问题，重复提问',
					'有诱导点赞关注等行为',
					'不规范转载',
					'存在不实信息',
					'存在人身攻击等不友善行为',
				],
				reject: {
					id: '',
					has: false,
					txt: '',
					remark: '',
					tag: [],
				},

				isChangeSec: false,
				changeId: '',
				choose: [],
				sectionList: [],
			}
		},
		components: {
			'reject-textarea': reject_textarea,
		},
		mounted(){
			this.getSection()
			this.getList_manualCheck();
			this.getList_answerManager();
			this.getList_archiveManager();

			h5PublicApi.tabNavTed('set','homeType','');
			h5PublicApi.tabNavTed('set','meIndexModel','');
			h5PublicApi.tabNavTed('set','meIndexNav','');
			h5PublicApi.tabNavTed('set','meIndexNav2','');
			h5PublicApi.tabNavTed('set','messageIndexModel','');
			h5PublicApi.tabNavTed('set','messageIndexNav','');
			h5PublicApi.tabNavTed('set','messageIndexNav2','');
		},
		methods: {
			replaceStr(input){
				return input.replace('<br/>','');
			},
			getSection(){
				this.h5Ajax('get','$/category/listFlatCatgories',{ 
					page: 1,
					pid: 0,
					size: 100,
					types: 1,
				}, true).then(r=>{
					this.sectionList = r
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			changeSection(v){ // 更改模块
				// console.log(v)
				this.changeId = v.id
				this.isChangeSec = true
				this.sectionList.map((item, i) => {
					if(item.id == v.categoryId) this.choose = [i]
				})
			},
			closeCollectBase(){
				this.isChangeSec = false
			},
			chooseCollectBase(index){
				if(this.choose[0]==index){
					this.choose = [];
				}else{
					this.choose = [index]
				}
			},
			resCollectBase(){
				// console.log(this.sectionList[this.choose[0]].id)
				this.h5Ajax("post", "$/questions/batchChangeQuestions", {
					ids: this.changeId,
					categoryId: this.sectionList[this.choose[0]].id
				}, true).then( res => {
					if(res === true){
						this.isChangeSec = false
						this.changeId = ''
						this.pagenum_manualCheck = 1
						this.pagesize_manualCheck = 10
						this.manualCheckList = []
						this.getList_manualCheck()
					}
				})
			},

			dateTime(timestamp){
				if(!timestamp){ return ''; }
				var date = new Date(timestamp);
				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			returnOvertime(type,timestamp){
				if(type==1){
					timestamp = 86400000-timestamp; // 24*60*60*1000
				}else{
					timestamp = timestamp-86400000; // 24*60*60*1000
				}

				var t = timestamp.toString();
				var t2 = Number(t.substring(0, t.length-3));
				var day = parseInt(t2/(24*60*60));
				var t3 = t2 - day*24*60*60;
				var hour = parseInt(t3/(60*60));

				var t4 = t3 - hour*60*60;
				var minute = parseInt(t4/60);
				var second = t4 - minute*60;

				function k(a){
					return (a<10 ? '0' : '')+a;
				}
						
				// return (day>0 ? day+'天' : k(hour)+':'+k(minute)+':'+k(second));
				return (day>0 ? day+'天'+k(hour)+'小时'+k(minute)+'分钟' : k(hour)+':'+k(minute));
			},
			returnRetDate(timestamp){
				if(!timestamp){ return ''; }
				var nowDateStamp = new Date().getTime();
				var k = nowDateStamp-timestamp;
				if(k<60*60*1000){ // 1小时内
					var t = parseInt(k/(60*1000));
					return (t<5?'刚刚':t+'分钟前');
				}else if(k<24*60*60*1000){ // 24小时内
					return parseInt(k/(60*60*1000))+'小时前';
				}

				var date = new Date(timestamp);
				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			clock_set(ids){
				if(ids==null){ // 清空定时器
					for(var i in answerManager_clock){
						clearInterval(answerManager_clock[i].obj);
						delete answerManager_clock[i];
					}
				}else{
					ids.forEach((v,i)=>{
						answerManager_clock[v.id] = {
							index: v.index,
							obj: setInterval(r=>{
								v.val += 1000;

								if(v.val>79200000 && v.val<=86400000){ // 超过22小时（22*60*60*1000）且未超过24小时 (24*60*60*1000)
									this.answerManagerList[v.index].state = 2;
									this.answerManagerList[v.index].stateTxt = '超时倒计时：<em>'+this.returnOvertime(1,v.val)+'</em>';
								}else if(v.val>86400000){ // 超过24小时 (24*60*60*1000)
									this.answerManagerList[v.index].state = 1;
									this.answerManagerList[v.index].stateTxt = '提问已超时：<em>'+this.returnOvertime(0,v.val)+'</em>';
								}
							},1000)
						}
					})
				}
			},
			tabModel(model){
				this.chooseModel = model;
				h5PublicApi.tabNavTed('set','adminIndexModel',model)
			},
			listenScroll_manualCheck(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_manualCheck();
				}
			},
			addMoreData_manualCheck() { //加载更多
				if(this.state_manualCheck){
					return false;
				}
				this.pagenum_manualCheck ++;
				this.getList_manualCheck();
			},
			getList_manualCheck(){
				this.state_manualCheck = true;

				// 获取人工审核列表
				this.h5Ajax('get','$/questions/checkQuestions',{
					page: this.pagenum_manualCheck,
					size: this.pagesize_manualCheck,
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.manualCheckList.push({
								id: d.id,
								open: false,
								title: d.title,
								user: d.creatorName,
								account: d.creatorMapperNumber,
								date: this.dateTime(d.createTime),
								txt: d.content.replace(/\r\n/g,"<br>").replace(/\n/g,"<br>"),
								relation: {
									id: d.relation==0?'':d.relation,
									title: d.relationTitle||'',
								},
								categoryId: d.categoryId,
								categoryName: d.categoryName,
							});
						}
						this.state_manualCheck = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_answerManager(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_answerManager();
				}
			},
			addMoreData_answerManager() { //加载更多
				if(this.state_answerManager){
					return false;
				}
				this.pagenum_answerManager ++;
				this.getList_answerManager();
			},
			getList_answerManager(){
				this.state_answerManager = true;

				if(this.pagenum_answerManager==1){
					this.clock_set(null);
				}

				// 获取回答与管理列表
				this.h5Ajax('get','$/questions/listSortPage',{
					keyword: '',
					page: this.pagenum_answerManager,
					categoryId: 0,
					size: this.pagesize_answerManager,
				}).then(r=>{
					if(r.content.length>0){
						var clock_group = [];
						var nowDateStamp = new Date().getTime();
						for(var i in r.content){
							var d = r.content[i];

							var state = 0; // [1 超时] [2 即将超时] [3 正常]
							var stateTxt = '';
							if(d.answerTotal==0){
								state = 3;
								var t = nowDateStamp-Number(d.createTime);
								stateTxt = '超时倒计时：<em>'+this.returnOvertime(1,t)+'</em>';
								if(t>79200000 && t<=86400000){ // 超过22小时（22*60*60*1000）且未超过24小时 (24*60*60*1000)
									state = 2;
								}else if(t>86400000){ // 超过24小时 (24*60*60*1000)
									state = 1;
									stateTxt = '提问已超时：<em>'+this.returnOvertime(0,t)+'</em>';
								}

								clock_group.push({
									id: d.id,
									index: i,
									val: t,
								});
							}

							var type = []; // [top 置顶] [prize 加精]
							if(d.top==1){
								type.push('top');
							}
							if(d.refining==1){
								type.push('prize');
							}

							this.answerManagerList.push({
								state: state, // [1 超时] [2 即将超时] [3 正常]
								stateTxt: stateTxt,
								type: type, // [top 置顶] [prize 加精]
								id: d.id,
								title: d.title,
								user: d.creatorName,
								account: d.creatorMapperNumber,
								date: this.dateTime(d.createTime),
								txt: d.content.replace(/\r\n/g,"<br>").replace(/\n/g,"<br>"),
							});
						}
						this.state_answerManager = false;

						if(clock_group.length>0){
							this.clock_set(clock_group);
						}
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_archiveManager(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_archiveManager();
				}
			},
			addMoreData_archiveManager() { //加载更多
				if(this.state_archiveManager){
					return false;
				}
				this.pagenum_archiveManager ++;
				this.getList_archiveManager();
			},
			getList_archiveManager(){
				this.state_archiveManager = true;

				// 获取归档管理列表
				this.h5Ajax('get','$/answers/archiveListPage',{
					page: this.pagenum_archiveManager,
					size: this.pagesize_archiveManager,
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.archiveManagerList.push(d)
						}
						this.state_archiveManager = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			openLi(index){
				this.manualCheckList[index].open = !this.manualCheckList[index].open;
			},
			openConfirm(type,txt,data,state){
				this.confirm = {
					id: data.id,
					has: true,
					state: (state?2:1),
					type: type,
					typeArr: data.type,
					txt: txt,
				};
			},
			closeConfirm(){
				this.confirm.has = false;
			},
			resConfirm(){
				if(this.confirm.id==''){
					return;
				}

				if(this.confirm.type=='check'){ // 审核通过
					this.h5Ajax('post','$/questions/checkPass',{
						id: this.confirm.id,
					}).then(r=>{
						this.confirm.has = false;

						this.pagenum_manualCheck = 1;
						this.state_manualCheck = false;
						this.manualCheckList = [];
						this.getList_manualCheck();

						this.pagenum_answerManager = 1;
						this.pagesize_answerManager = 10;
						this.state_answerManager = false;
						this.answerManagerList = [];
						this.getList_answerManager();

						window.h5GetMessageCount && window.h5GetMessageCount();
					}).catch(err => {
						console.error('err:' + err)
					})
				}else if(this.confirm.type=='top'){ // 置顶
					this.h5Ajax('post','$/questions/'+(this.confirm.typeArr.indexOf('top')>=0?'unTop':'top'),{
						id: this.confirm.id,
					}).then(r=>{
						this.confirm.has = false;

						this.pagenum_answerManager = 1;
						this.state_answerManager = false;
						this.answerManagerList = [];
						this.getList_answerManager();
					}).catch(err => {
						console.error('err:' + err)
					})
				}else if(this.confirm.type=='prize'){ // 加精
					this.h5Ajax('post','$/questions/'+(this.confirm.typeArr.indexOf('prize')>=0?'unRefining':'refining'),{
						id: this.confirm.id,
					}).then(r=>{
						this.confirm.has = false;
						
						this.pagenum_answerManager = 1;
						this.state_answerManager = false;
						this.answerManagerList = [];
						this.getList_answerManager();
					}).catch(err => {
						console.error('err:' + err)
					})
				}else if(this.confirm.type=='remove'){ // 删除
					this.h5Ajax('post','$/questions/delete',{
						id: this.confirm.id,
					}).then(r=>{
						this.confirm.has = false;
						
						this.pagenum_answerManager = 1;
						this.state_answerManager = false;
						this.answerManagerList = [];
						this.getList_answerManager();
					}).catch(err => {
						console.error('err:' + err)
					})
				}else if(this.confirm.type=='archive'){ // 取消归档
					this.h5Ajax('post','$/answers/unArchive',{
						id: this.confirm.id,
					}).then(r=>{
						this.confirm.has = false;
						
						this.pagenum_archiveManager = 1;
						this.state_archiveManager = false;
						this.archiveManagerList = [];
						this.getList_archiveManager();
					}).catch(err => {
						console.error('err:' + err)
					})
				}
			},
			openReject(txt,data){
				this.reject = {
					has: true,
					id: data.id,
					txt: txt,
					remark: '',
					tag: [],
				};
			},
			chooseRejectTag(index){
				if(this.reject.tag.indexOf(index)>=0){
					this.reject.tag.splice(this.reject.tag.indexOf(index),1);
				}else{
					this.reject.tag.push(index);
					document.getElementById('rejectTextareaObj').focus();
				}
			},
			closeReject(){
				this.reject.has = false;
			},
			resReject(){
				var tag = [];
				this.reject.tag.forEach((v,i)=>{
					tag.push(this.rejectArr[v]);
				})

				var txt = this.reject.remark;
				if(tag.length==0&&txt==''){
					alert('请输入或选择驳回理由');
					return;
				}

				this.h5Ajax('post','$/questions/checkFail',{
					failReason: tag.join('，')+(tag.length>0&&txt!=''?'，':'')+txt,
					id: this.reject.id,
				}).then(r=>{
					this.reject.has = false;

					this.pagenum_manualCheck = 1;
					this.state_manualCheck = false;
					this.manualCheckList = [];
					this.getList_manualCheck();

					window.h5GetMessageCount && window.h5GetMessageCount();
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			likeItem(txt){
				alert(txt);
			},
			collectItem(txt){
				alert(txt);
			},
			toDetail(data){
				// this.$router.replace('/admin/detail');
				this.$router.replace({ path: '/model/detail', query: { id: data.id, type: 'adminManager' } });
			},
		},
	}
</script>

<style scoped>
	@import './index'
</style>



// WEBPACK FOOTER //
// src/app/pages/admin/index/index.vue